import { render, staticRenderFns } from "./DynamicOffer.vue?vue&type=template&id=207015e2&"
import script from "./DynamicOffer.vue?vue&type=script&lang=js&"
export * from "./DynamicOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports